module.exports = __webpack_public_path__ + "assets/img/congrats.2cf46baf.svg";